module.exports = __webpack_public_path__ + "static/media/16UNODC32.475cebf8.jpg";